<template>
  <div>
    <form-model title="签字面板" width="400" ref="formModel">
      <Button slot="btn" type="primary" @click="qianzi">提交签字</Button>
    </form-model>
  </div>
</template>
<script>
import fields from "./forms/fields";
export default {
  data() {
    return {
      title: "",
      forms: fields['qianzi'],
      item: {
        name: '',
        job: "",
        time: Date.now(),
        opinion: "同意",
        title: "",
        fileList: []
      },
      searchItem: { id: '' }
    };
  },
  methods: {
    reach(v) {
      console.log(v);
      this.item.title = v.title;
      this.item.job = v.nodeName;
      this.item.no=v.title;
      this.item.formId = v.docId; //表单id
      //this.searchItem.id = v.docId;

      this.getUser();
      this.$refs.formModel.reach(this.forms, this.item);
    },
    open() {
      this.$refs.formModel.reach(this.forms, this.item);
    },
    qianzi() {
      this.utils.loading(this, "加载中");
      console.log(this.item);
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-cost/sign/confirm",
        data: this.item,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.$refs.formModel.close();
          this.$emit('ok');
        }
      });
    },
    getUser() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/account/getUserItem",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.item.name = this.utils.text(data.name, "");

      });
    },

  },
};
</script>


// WEBPACK FOOTER //
// src/components/diaodu/feiyongqianzi.vue